// extracted by mini-css-extract-plugin
module.exports = {"title":"_2Q73m9","titleHover":"_2RsMZc"};